module.exports = require('../index');



// WEBPACK FOOTER //
// ./src/entry/core.js